import { current } from 'immer';
import { shouldUpdateState } from './helpers';
import { initialState } from './initialState';

export const coreReducers = {
    reset(state) {
        Object.assign(state, initialState);
    },
    newLead(state, action) {
        state.lead = action.payload;
    },
    leadPage(state, action) {
        state.pageDetail = action.payload;
    },
    startLoading(state) {
        state.isLoading = true;
    },
    startLoadingData(state, action) {
        state.isLoadingFinish = action.payload;
    },
    setLoadingApis(state, action) {
        state.loadingApis = action.payload;
    },
    setLoadingForExport(state, action) {
        state.loadingForExport = action.payload;
    },
    setLoadingForLead(state, action) {
        state.loadingForLead = action.payload;
    },
    setLoadingForClincheckLead(state, action) {
        state.loadingForClincheckLead = action.payload;
    },
    startArchivedLoading(state, action) {
        state.archivedLoading = action.payload;
    },
    // HAS ERROR
    hasError(state, action) {
        state.isLoading = false;
        state.error = action.payload || 'Something went wrong';
    },
    clearError(state) {
        state.error = '';
    },
    saveLead(state, action) {
        state.isLoading = false;
        state.createLead = action.payload;
    },
    saveConsentLead(state, action) {
        state.isLoading = false;
        state.createLeadForConsent = action.payload;
    },
    saveNewLeadDetail(state, action) {
        state.isLoading = false;
        state.newLeadDetail = {
            ...state.newLeadDetail,
            ...action.payload
        };
    },
    beginExistingLeadBooking(state, action) {
        // A user-selected new booking owns a fresh draft. Never inherit another
        // attempt's appointment, payment recipient, assignees or outcome fields.
        state.newLeadDetail = {
            personalDetail: action.payload ? { ...action.payload } : null,
            personalDetailEdited: false,
        };
    },
    savePersonalLeadDetails(state, action) {
        state.newLeadDetail = {
            ...state.newLeadDetail,
            personalDetail: {
                ...(state.newLeadDetail?.personalDetail ?? {}),
                ...action.payload
            }
        }
    },
    clearLead(state) {
        state.createLead = {
            personalDetail: null
        };
        state.newLeadDetail = {
            personalDetail: null
        };
        state.markAsComplete = false;
        state.followLead = null;
        state.followLeadNotFound = false;
        state.BookingAttendance = null;
        state.activeTab = 0;
        state.followUpLead = null;
        state.isDentallyBooking = false;
        state.dentallySlot = null;
        state.dentallyPatientId = null;
        state.pendingDentallySync = null;
        // Reset booking state to prevent stale data leaking across sessions (Priority 11 fix)
        state.isAppointmentBooked = null;
    },
    clearConsentData(state) {
        state.createLeadForConsent = {};
        state.consentLink = null;
    },
    clearTableData(state) {
        state.lead = {
            results: []
        };
        state.newDashLead = {
            results: []
        };
        state.newStatusLead = {
            results: []
        };
        state.consultantAttendStatusLead = {
            results: []
        };
        state.consultantClinCheckStatusLead = {
            results: []
        };
        state.consultantBookedStatusLead = {
            results: []
        };
        state.treatmentStartedStatusLead = {
            results: []
        };
        state.archivedList = [];
    },
    updateLead(state, action) {
        state.lead.results = action.payload.results;
        state.lead.count = action.payload.count;
    },
    updateDashNewLead(state, action) {
        const currentState = current(state.newDashLead);
        const newState = { results: action.payload.results, count: action.payload.count }

        if (shouldUpdateState(currentState, newState)) {
            state.newDashLead.results = action.payload.results;
            state.newDashLead.count = action.payload.count;
        }
    },
    searchAPIdata(state, action) {
        state.searchedLead = action.payload;
        state.isLoading = false;
    },
    setUniversalSearchResults(state, action) {
        state.isLoading = false;
        const existingCampaigns = state.universalSearchResults?.results?.campaigns;
        state.universalSearchResults = action.payload;
        // Preserve campaign results merged by searchCampaigns (fetched concurrently, may resolve first)
        if (existingCampaigns && state.universalSearchResults?.results) {
            state.universalSearchResults.results.campaigns = existingCampaigns;
        }
    },
    mergeCampaignSearchResults(state, action) {
        // Merge campaign results into existing universalSearchResults without overwriting other categories
        if (!state.universalSearchResults) {
            state.universalSearchResults = { results: {} };
        }
        if (!state.universalSearchResults.results) {
            state.universalSearchResults.results = {};
        }
        state.universalSearchResults.results.campaigns = action.payload;
    },
    addTaskSearchLead(state, action) {
        state.taskSearchLead = action.payload;
        state.isLoading = false;
    },
    clearApiData(state) {
        state.searchedLead = null;
        state.universalSearchResults = null;
    },
    clearTaskLead(state) {
        state.taskSearchLead = null;
    },
    updateSteps(state, action) {
        state.attendance = action.payload;
    },
    updateBookingSteps(state, action) {
        state.BookingAttendance = action.payload;
    },
    saveLeadDetail(state, action) {
        state.leadDetail = action.payload;
    },
    setLeadDetailNotFound(state, action) {
        state.leadDetailNotFound = action.payload;
    },
    tableLead(state, action) {
        state.tableRowLead = action.payload;
    },
    clearLeadDetail(state) {
        state.leadDetail = null;
    },
    archivedLeadSlice(state, action) {
        state.archivedLead = action.payload;
    },
    archiveLead(state, action) {
        state.archivedList = action.payload;
    },
    setArchivedLeadTags(state, action) {
        state.archiveLeadTags = action.payload;
    },
    addContactedLead(state, action) {
        state.contactedLead = action.payload;
    },
    updateConsentLink(state, action) {
        state.consentLink = action.payload;
    },
    updateActiveStep(state, action) {
        state.activeTab = action.payload;
    },
    updateCompleteStatus(state, action) {
        state.markAsComplete = action.payload;
    },
    contactLeadSlice(state, action) {
        state.contactLead = action.payload;
    },
    selectLeads(state, action) {
        state.multiLead = action.payload;
    },
    updateTableType(state, action) {
        state.tableType = action.payload;
    },
    duplicateSelectLeads(state, action) {
        state.duplicateMultiLead = action.payload;
    },
    setMergeTags(state, action) {
        state.mergeTags = action.payload;
    },
    setAction(state, action) {
        state.action = action.payload;
    },
    updateSendReminderDuringLeadCreate(state, action) {
        state.sendReminderDuringLeadCreate = action.payload;
    },
    // Staff-side counterpart to the patient acknowledgement suppression:
    // whether creating this lead should email the practice about it.
    updateNotifyPracticeDuringLeadCreate(state, action) {
        state.notifyPracticeDuringLeadCreate = action.payload;
    },
    updateExistingAudienceList(state, action) {
        state.existingAudienceLeadList = action.payload;
    },
    // Dentally booking flow reducers
    setDentallyBooking(state, action) {
        state.isDentallyBooking = action.payload;
    },
    setDentallySlot(state, action) {
        state.dentallySlot = action.payload;
    },
    setDentallyPatientId(state, action) {
        state.dentallyPatientId = action.payload;
    },
    setPendingDentallySync(state, action) {
        state.pendingDentallySync = action.payload;
    },
    clearDentallyState(state) {
        state.isDentallyBooking = false;
        state.dentallySlot = null;
        state.dentallyPatientId = null;
        state.pendingDentallySync = null;
    },
    updateDateFormat(state, action) {
        state.dateFormat = action.payload;
    },
    updateArchiveDateFormat(state, action) {
        state.dateArchiveFormat = action.payload;
    },
    updateAppointmentDateFormat(state, action) {
        state.dateAppointmentFormat = action.payload;
    },
    updateconsultationDateFormat(state, action) {
        state.consultationDateFormat = action.payload;
    },
    updateLastContactDateFormat(state, action) {
        state.dateLastContactFormat = action.payload;
    },
    updateAttendedDateFormat(state, action) {
        state.dateAttendedFormat = action.payload;
    },
    leadStatusNew(state, action) {
        state.newStatusLead = action.payload;
    },
    leadStatusConsultantAttended(state, action) {
        state.consultantAttendStatusLead = action.payload;
    },
    leadStatusConsultantClinCheckAttended(state, action) {
        state.consultantClinCheckStatusLead = action.payload;
    },
    leadStatusAttendedChecklists(state, action) {
        state.attendedChecklistsStatusLead = action.payload;
    },
    leadStatusConsultantBooked(state, action) {
        // Dedup at the single chokepoint so every fetch path (initial load,
        // filter change, pagination) is covered. The BE cross-join from
        // concurrent status + booked-with appointment filters can return the
        // same lead id twice; String() coercion handles int/string mismatch.
        const seen = new Set();
        const results = (action.payload?.results || []).filter((item) => {
            if (item?.id == null) return true;   // keep id-less rows as-is
            const key = String(item.id);
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
        state.consultantBookedStatusLead = { ...action.payload, results };
    },
    leadStatusFailedToAttend(state, action) {
        state.failedToAttendStatusLead = action.payload;
    },
    leadStatusClosed(state, action) {
        state.closedStatusLead = action.payload;
    },
    leadStatusTreatmentStarted(state, action) {
        state.treatmentStartedStatusLead = action.payload;
    },
    updateCounter(state, action) {
        const currentState = current(state.counter);

        if (shouldUpdateState(currentState, action.payload)) {
            state.counter = action.payload;
        }
    },
    addDashboardStatusesSummery(state, action) {
        state.dashboardStatusesSummery = action.payload;
    },
    clearDashboardStatusesSummery(state) {
        state.dashboardStatusesSummery = [];
    },
    leadSummaryListingSlice(state, action) {
        state.leadSummaryListing = action.payload;
    },
    leadStatusSummaryListingSlice(state, action) {
        state.leadStatusSummaryListing = action.payload;
    },
    leadArchivedSummaryListingSlice(state, action) {
        state.leadArchivedSummaryListing = action.payload;
    },
    leadTreatmentsListingSlice(state, action) {
        state.leadTreatmentsListing = action.payload;
    },
    addAutoMatedMessages(state, action) {
        state.autoMatedMessages = action.payload;
    },
    chatbotConversationSlice(state, action) {
        state.chatbotConversation = action.payload;
    },
};
